import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface RoleSelectionData {
  rememberRole: boolean;
}

export interface RoleSelectionResult {
  role: 'parent' | 'employee';
  remember: boolean;
}

@Component({
  selector: 'app-role-selection-dialog',
  templateUrl: './role-selection-dialog.component.html',
  styleUrls: ['./role-selection-dialog.component.scss'],
})
export class RoleSelectionDialogComponent {
  public dialogRef = inject(MatDialogRef<RoleSelectionDialogComponent>);
  public data = inject<RoleSelectionData>(MAT_DIALOG_DATA);

  constructor() {}
}